import api from '@/utils/axios';
import type { RegisterReference } from '@/shared/types/users.types';

export async function fetchRegisterReference(): Promise<RegisterReference> {
    const res = await api.get('/register/reference');
    const data = res.data.data ?? res.data;

    return {
        types: data.types ?? [],
        zones: data.zones ?? [],
        vehicle_types: data.vehicle_types ?? [],
        specializations: data.specializations ?? [],
        availability_slots: data.availability_slots ?? [],
        categories: data.categories ?? [],
    };
}
